// extracted by mini-css-extract-plugin
module.exports = {"container":"MyMaterialsList_container__UdB-H","skeleton-anim":"MyMaterialsList_skeleton-anim__3ublH","fadeIn1":"MyMaterialsList_fadeIn1__1ip9_"};